var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.items),function(item,i){return [_c('hidden-input',_vm._b({key:("item-" + i),ref:("item-" + i),refInFor:true,staticClass:"my-2",attrs:{"editable":!_vm.readonly,"scope":"person"}},'hidden-input',item,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }